import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_layout_content = _resolveComponent("a-layout-content")!

  return (_openBlock(), _createBlock(_component_a_layout_content, { style: {"padding":"0 250px"} }, {
    default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
      _createElementVNode("h2", { style: {"text-align":"center"} }, "欢迎", -1)
    ]))]),
    _: 1
  }))
}